import get from 'lodash/get';
import { convertHexToRGB } from '../../../../utils';

const styles = ({ fontSize, color }) => ({
  topPanelContainer: {
    backgroundColor: `${convertHexToRGB(get(color, 'borderColor'), 0.1)}`,
    minHeight: '90px',
    borderBottom: '1px solid #ccc',
  },
  panelContainer: {
    border: 0,
    paddingBottom: 0,
    height: '90px',
    borderLeft: '1px solid',
    borderColor: get(color, 'borderColor'),
    marginLeft: '36px',
  },
  marginPanelContainer: {
    padding: '0',
  },
  detailsContainer: {
    padding: '20px 36px',
  },
  paper: {
    paddingRight: 0,
    marginTop: '1px',
  },
  paperKey: {
    paddingRight: 0,
    marginTop: '1px',
    border: '1px solid',
    borderTop: 0,
    borderColor: get(color, 'borderColor'),
  },
  disconnectedBackground: {
    backgroundColor: get(color, 'lightBackground'),
  },
  hideFooterContainer: {
    display: 'none',
  },
  showFooterContainer: {
    display: 'visible',
  },
  title: {
    fontSize: `${get(fontSize, 'smallTitle')} !important`,
    marginTop: 0,
  },
  selectContainer: {
    margin: '20px',
    marginTop: 0,
    marginLeft: '35px',
    marginRight: '35px',
  },
  keyStoreTypeContainer: {
    marginTop: '20px',
    marginLeft: '35px',
    marginRight: '35px',
    width: '100%',
  },
  keyStoreTypeDiv: {
    margin: 0,
    width: '45%',
    float: 'left',
    marginBottom: '20px',
  },
  keyStoreIdDiv: {
    margin: 0,
    width: '45%',
    marginBottom: '20px',
    float: 'left',
    marginLeft: '5px',
  },
  keyStoreIdLabel: {
    marginTop: '15px',
  },
  keyStoreIdHiddenLabel: {
    '& label': {
      lineHeight: 0,
    },
  },
  displayToolTip: {
    color: get(color, 'primaryButtonBackground'),
    fontSize: '15px',
    paddingTop: '5px',
    marginLeft: '2px',
  },
});

export default styles;
